// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DescriptionLabel from './view'

export default function DescriptionLabelFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DescriptionLabel">
      <DescriptionLabel {...props}>
        {children}
      </DescriptionLabel>
    </Flow>
  )
}
